module.exports = __webpack_public_path__ + "static/media/richlink.3028be14.jpg";